import { render, staticRenderFns } from "./GoalsABMComponent.vue?vue&type=template&id=55295c7e&scoped=true"
import script from "./GoalsABMComponent.js?vue&type=script&lang=js&external"
export * from "./GoalsABMComponent.js?vue&type=script&lang=js&external"
import style0 from "./GoalsABMComponent.vue?vue&type=style&index=0&id=55295c7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55295c7e",
  null
  
)

export default component.exports